module.exports = __webpack_public_path__ + "img/Gallery_1_18.662be5a7.jpeg";